<template>
  <div class="purchase-info">
    <Navbar title="参与详情"></Navbar>
    <van-search
      v-model="listQuery.phone"
      type="number"
      placeholder="输入手机号查询订单"
      show-action
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-tabs v-model="active" @click="handleToggleTab">
      <van-tab title="全部">
        <div class="order" v-for="(item, index) in orderList" :key="index">
          <van-row type="flex" class="order-num" justify="space-between">
            <van-col>订单编号：{{ item.orderNo }}</van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 0"
            >
              未激活
            </van-col>
            <van-col class="status" v-if="item.activationStatus === 1">
              已激活
            </van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 2"
            >
              已过期
            </van-col>
          </van-row>
          <div class="activity-name">
            <van-cell
              :title="item.promotionName"
              is-link
              :to="{ path: 'orderDetail', query: { orderNo: item.orderNo } }"
            />
          </div>
          <van-row type="flex" class="user-info" justify="space-between">
            <van-col class="phone">{{ item.phone }}</van-col>
            <van-col class="price">￥{{ item.payAmount / 100 }}</van-col>
          </van-row>
          <van-row type="flex" class="order-info" justify="space-between">
            <van-col>付款时间:{{ item.payTime }}</van-col>
            <van-col>过期时间:{{ item.expiresTime }}</van-col>
          </van-row>
        </div>
      </van-tab>
      <van-tab title="未激活">
        <div class="order" v-for="(item, index) in orderList" :key="index">
          <van-row type="flex" class="order-num" justify="space-between">
            <van-col>订单编号：{{ item.orderNo }}</van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 0"
            >
              未激活
            </van-col>
            <van-col class="status" v-if="item.activationStatus === 1">
              已激活
            </van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 2"
            >
              已过期
            </van-col>
          </van-row>
          <div class="activity-name">
            <van-cell
              :title="item.promotionName"
              is-link
              :to="{ path: 'orderDetail', query: { orderNo: item.orderNo } }"
            />
          </div>
          <van-row type="flex" class="user-info" justify="space-between">
            <van-col class="phone">{{ item.phone }}</van-col>
            <van-col class="price">￥{{ item.payAmount / 100 }}</van-col>
          </van-row>
          <van-row type="flex" class="order-info" justify="space-between">
            <van-col>付款时间:{{ item.payTime }}</van-col>
            <van-col>过期时间:{{ item.expiresTime }}</van-col>
          </van-row>
        </div>
      </van-tab>
      <van-tab title="已激活">
        <div class="order" v-for="(item, index) in orderList" :key="index">
          <van-row type="flex" class="order-num" justify="space-between">
            <van-col>订单编号：{{ item.orderNo }}</van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 0"
            >
              未激活
            </van-col>
            <van-col class="status" v-if="item.activationStatus === 1">
              已激活
            </van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 2"
            >
              已过期
            </van-col>
          </van-row>
          <div class="activity-name">
            <van-cell
              :title="item.promotionName"
              is-link
              :to="{ path: 'orderDetail', query: { orderNo: item.orderNo } }"
            />
          </div>
          <van-row type="flex" class="user-info" justify="space-between">
            <van-col class="phone">{{ item.phone }}</van-col>
            <van-col class="price">￥{{ item.payAmount / 100 }}</van-col>
          </van-row>
          <van-row type="flex" class="order-info" justify="space-between">
            <van-col>付款时间:{{ item.payTime }}</van-col>
            <van-col>过期时间:{{ item.expiresTime }}</van-col>
          </van-row>
        </div>
      </van-tab>
      <van-tab title="已过期">
        <div class="order" v-for="(item, index) in orderList" :key="index">
          <van-row type="flex" class="order-num" justify="space-between">
            <van-col>订单编号：{{ item.orderNo }}</van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 0"
            >
              未激活
            </van-col>
            <van-col class="status" v-if="item.activationStatus === 1">
              已激活
            </van-col>
            <van-col
              class="status nonactivated"
              v-if="item.activationStatus === 2"
            >
              已过期
            </van-col>
          </van-row>
          <div class="activity-name">
            <van-cell
              :title="item.promotionName"
              is-link
              :to="{ path: 'orderDetail', query: { orderNo: item.orderNo } }"
            />
          </div>
          <van-row type="flex" class="user-info" justify="space-between">
            <van-col class="phone">{{ item.phone }}</van-col>
            <van-col class="price">￥{{ item.payAmount / 100 }}</van-col>
          </van-row>
          <van-row type="flex" class="order-info" justify="space-between">
            <van-col>付款时间:{{ item.payTime }}</van-col>
            <van-col>过期时间:{{ item.expiresTime }}</van-col>
          </van-row>
        </div>
      </van-tab>
    </van-tabs>
    <div class="statistics">
      <div>
        <span>累计购买</span>
        <span>{{ statisticsData.paidQuantity }}</span>
        <span>份</span>
      </div>
      <div>
        <span>累计激活</span>
        <span>{{ statisticsData.activationQuantity }}</span>
        <span>份</span>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { orderList, statistics } from "@/api/order";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      value: "",
      active: "全部",
      listQuery: {
        page: 1,
        size: 1000,
        phone: "",
        status: "",
        promotionId: ""
      },
      orderList: [],
      statisticsData: {}
    };
  },
  mounted() {
    this.handleOrderList();
    this.handleStatistics();
  },
  methods: {
    // 搜索
    onSearch() {
      this.handleOrderList();
    },
    // 订单列表
    handleOrderList() {
      orderList(this.listQuery).then(res => {
        // console.log("订单列表:", res);
        this.orderList = res;
      });
    },
    // 订单统计
    handleStatistics() {
      statistics().then(res => {
        // console.log("订单统计:", res);
        this.statisticsData = res;
      });
    },
    // 标签页切换
    handleToggleTab(index) {
      switch (index) {
        case 0:
          this.listQuery.status = "";
          break;
        case 1:
          this.listQuery.status = 0;
          break;
        case 2:
          this.listQuery.status = 1;
          break;
        case 3:
          this.listQuery.status = 2;
          break;
        default:
          break;
      }
      this.handleOrderList();
    }
  }
};
</script>
<style lang="scss" scoped>
.purchase-info {
  overflow: hidden;

  .order {
    padding: 10px 10px;
    margin-bottom: 10px;
    background-color: #f6f7f9;
    border-radius: 10px;

    .order-num {
      align-items: center;
      font-size: 12px;

      .status {
        padding: 2px;
        border-radius: 5px;
        color: #fff;
        line-height: 1;
        background-color: green;
      }

      .nonactivated {
        background-color: #ccc;
      }
    }

    .activity-name {
      .van-cell {
        padding: 10px 0;
        text-align: left;
        background-color: #f6f7f9;
      }
    }

    .user-info {
      padding-bottom: 5px;
      border-bottom: 1px solid #e4e4e4;

      .phone {
        color: blue;
      }

      .price {
        color: red;
      }
    }

    .order-info {
      padding-top: 5px;
      font-size: 12px;
    }
  }

  .statistics {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    background-color: #fff;

    div {
      width: 50%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      box-sizing: border-box;

      span:nth-child(2) {
        color: red;
      }
    }
  }
}
</style>
<style lang="scss">
.purchase-info {
  .van-search__content {
    border-radius: 50px;
  }

  .van-tabs__content {
    padding: 10px 20px;
  }
}
</style>
